<template>
  <span>
    <b-dropdown size="sm" :variant="currentStatus.color" :disabled="saving">
      <template slot="button-content">
        <i class="fa fa-spinner fa-spin mr-1" v-if="saving"></i>
        {{currentStatus.label}}
      </template>

      <b-dropdown-item v-for="status in selectableStatuses" :key="status.id" :class="`bg-${status.color}`" style="color: #fff !important;" @click="updateStatus(status.id)">{{status.label}}</b-dropdown-item>
    </b-dropdown>

    <text-alert :alert.sync="alert" class="ml-1"></text-alert>
  </span>
</template>

<script>
export default {
  props: {
    orderList: Object
  },
  data () {
    return {
      saving: false,
      alert: false
    }
  },
  computed: {
    status () {
      return this.orderList.status
    },
    statuses () {
      return [
        { id: 'concept', label: 'Concept', color: 'danger' },
        { id: 'ordered', label: 'Besteld', color: 'info' },
        { id: 'delivered', label: 'Geleverd', color: 'info' },
        { id: 'verify', label: 'Nog te controleren', color: 'danger' },
        { id: 'incomplete', label: 'Incompleet', color: 'danger' },
        { id: 'completed', label: 'Afgerond', color: 'success' }
      ]
    },
    currentStatus () {
      return this.statuses.find(s => s.id === this.status)
    },
    selectableStatuses () {
      return this.statuses.filter(s => s.selectable !== false)
    }
  },
  methods: {
    updateStatus (newStatus) {
      const oldStatus = this.orderList.status
      this.orderList.status = newStatus

      const data = {
        status: newStatus
      }

      this.saving = true
      this.$http.patch(`/order-list/${this.orderList.id}`, data)
        .then((response) => {
          this.saving = false
          this.alert = { variant: 'success', message: 'Opgeslagen' }
        })
        .catch(() => {
          this.saving = false
          this.orderList.status = oldStatus
          this.$swal('Oeps! 😳', `Er is iets fout gegaan bij het opslaan van de status. Probeer het opnieuw.`, 'error')
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// OrderListStatusBadge.vue?663eb2b0